import { Skeleton } from '@/shared/ui'

export const RoomItemSkeleton = () => {
  return (
    <div>
      <Skeleton className="mb-3 h-[224px] w-[336px] rounded-sm" />
      <Skeleton className="mb-1 h-6 w-[196px] rounded-sm" />
      <Skeleton className="mb-1 h-5 w-[142px] rounded-sm" />
      <Skeleton className="mb-1.5 h-5 w-[160px] rounded-sm" />
      <Skeleton className="mb-1 h-6.5 w-[129px] rounded-sm" />
      <Skeleton className="h-5 w-[228px] rounded-sm" />
    </div>
  )
}
